<template>
	<div>
		<AsyncComponent v-if="content" :content="content" />
	</div>
	<div ref="observe"></div>
</template>

<script>
import axios from 'axios';
import AsyncComponent from './AsyncComponent.vue'; 

export default {
	components: {
		AsyncComponent
	},
	props: {
		url: {
			type: String,
			required: true
		},
		viewportObserver: {
			type: Boolean,
			required: false,
			default: false
		},		
		once: {
			type: Boolean,
			required: false,
			default: true
		},
		append: {
			type: Boolean,
			required: false,
			default: false
		},
		pagination: {
			type: Boolean,
			required: false,
			default: false
		},
	},
	data() {
		return {
			content: '',
			error: null,
			loaded: null,
			page: 0
		};
	},
	mounted() {
		if(this.viewportObserver) {
			this.addObserver();
		} else {
			this.fetchContent();
		}
	},
	methods: {
		addObserver: function() {
			
			var component = this;
			
			const options = {
				root: null,
				rootMargin: '0% 0% 500px 0%',
				threshold: 0
			};
			
			var elementToObserve = this.$refs.observe;
			
			component.observer = new IntersectionObserver((entries) => {
				entries.forEach(entry => {
					if (entry.isIntersecting) { 						
						if(
							!component.loading &&
							!component.error && 
							(!component.loaded || !component.once) 
							) 
						{
							component.$logger('app/component/async-render/in-view-port')
						  component.fetchContent();
						} else {
							//console.log('in viewport DONT fetch content!')
						}
					} else {
						//console.log('out of viewport')
					}
				});
			}, options);
		
			component.observer.observe(elementToObserve); 
		},		
		async fetchContent() {
			
			this.loading = true;
			
			this.$logger('app/component/async-render/fetch-content:' + this.url);
			
			var url;
			
			try {
				
				if(this.pagination) {
					this.page += 1;
					url = this.url + '/p' + this.page;
				} else {
					url = this.url;
				}

 				const response = await axios.get(url);
				
				// Append or set
				if(this.append) {
					this.content += response.data;
				} else {
					this.content = response.data;
				}
				
				this.loading = false;
				this.loaded = true;
			} catch (error) {
				this.error = 'Failed to load content!';
				
			}
		}
	}
};
</script>
